export const balancingMarketMenuName = 'Menu::MenuG:BalancingMarket';
